import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import { Formik } from "formik";
import { RpcError } from "grpc-web";
import { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AuthContext, AuthContextInterface } from "../../contexts";
import { S3CredentialsContext, UserDetailsContext } from "../../contexts";
import { S3CredentialsContextInterface } from "../../contexts";
import { UserDetailsContextInterface } from "../../contexts";
import { styles } from "../../pages/MyTracks/styles";
import { ContainerModal } from "../../pages/MyTracks/styles";
import { InviteTemplate, Track } from "../../proto/api_pb";
import { TrackState, FileState } from "../../proto/api_pb";
import { AudioMetadata, GetTracksResponse } from "../../proto/api_pb";
import { Collaborator } from "../../proto/api_pb";
import { TrackFile, TrackFileType, User } from "../../proto/api_pb";
import { InvitedCollaborator } from "../../proto/api_pb";
import { InvitedCollaboratorState } from "../../proto/api_pb";
import { fetchTracks, postTrackFile } from "../../services/trackService";
import { sendInvites } from "../../services/trackService";
import { awaitableUploadToS3 } from "../../utils/S3Utils";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import Mixpanel from "../../utils/mixpanel";
import { emailRegex } from "../constants";
import { MultipleFilesUploadModalProps, newAddTrack } from "./types";
import { APP_BACKGROUND_COLOR, TEXT_COLOR } from "../../theme";
import { getBpm } from "../../utils/bpmUtil";
import { TrackFilesUploadForm } from "../TrackFilesUploadForm/TrackFilesUploadForm";
const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;

const MultipleFileUploadModal: React.FC<MultipleFilesUploadModalProps> = ({
  open,
  handleClose,
  track,
  handleFileAdded,
  setUploadingFilesDetailsList,
  setIsUploading,
  setUploadingCardsStatusList,
  parentFolderId,
}) => {
  const { getValidAccessToken } = useGetValidAccessToken();
  const [fileLabel, setFileLabel] = useState("");
  const [showTrackVersionTooltip, setShowTrackVersionTooltip] = useState(false);
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const [emailInvite, setEmailInvite] = useState("");
  const [emailInviteList, setEmailInviteList] = useState<string[]>([]);
  const [collaborators, setCollaborators] = useState<Array<Collaborator>>([]);
  const [collabVal, setCollabVal] = useState("");
  const [usersList, setUsersList] = useState<Array<User>>([]);
  const { allUsers, userName } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const [showCollabTooltip, setShowCollabTooltip] = useState(false);
  const [addedCollabIds, setAddedCollabIds] = useState<string[]>([]);
  const [allTracksList, setAllTracksList] = useState<Track[]>([]);
  const [selectedTracksList, setSelectedTracksList] = useState<string[]>([]);
  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken } =
    useContext<S3CredentialsContextInterface>(S3CredentialsContext);
  const [files, setFiles] = useState<any[]>([]);

  const getAllTracks = useCallback(async () => {
    if (!track?.getId()) {
      const token = await getValidAccessToken();
      try {
        const response = (await fetchTracks(
          token,
          userId
        )) as GetTracksResponse;
        const filteredTracks = response
          .getTracksList()
          .map((track) => track.getTrack())
          .filter(
            (track): track is Track =>
              track?.getState() !== TrackState.TRACK_STATE_DELETED
          );
        setAllTracksList(filteredTracks);
      } catch (e) {
        const error = e as RpcError;
        console.log(error.message);
      }
    }
  }, [getValidAccessToken, track, userId]);

  useEffect(() => {
    if (userId !== "") {
      getAllTracks();
    }
  }, [userId, getValidAccessToken, getAllTracks]);

  const handleProgress = (pNum: number, idx: number, filesList: any[]) => {
    filesList[idx].uploadProgress = Math.floor(pNum);
    const modifiedList = [...filesList];
    setUploadingFilesDetailsList(modifiedList);
  };

  useEffect(() => {
    const userL = allUsers.filter((user) => user.getUsername() !== userName);
    setUsersList(userL);
  }, [allUsers, userName]);

  const getFileType = (file: any) => {
    if (file.type.startsWith("image/")) {
      return TrackFileType.TRACK_FILE_TYPE_ARTWORK;
    } else if (
      file.name.endsWith(".abl") ||
      file.name.endsWith(".ablbundle") ||
      file.name.endsWith(".adg") ||
      file.name.endsWith(".agr") ||
      file.name.endsWith(".adv") ||
      file.name.endsWith(".alc") ||
      file.name.endsWith(".alp") ||
      file.name.endsWith(".als") ||
      file.name.endsWith(".ams") ||
      file.name.endsWith(".amxd") ||
      file.name.endsWith(".asd") ||
      file.name.endsWith(".ask") ||
      file.name.endsWith(".ptx") ||
      file.name.endsWith(".logic") ||
      file.name.endsWith(".logicx") ||
      file.name.endsWith(".band") ||
      file.name.endsWith(".band.zip") ||
      file.name.endsWith(".aup3") ||
      file.name.endsWith(".zip") ||
      file.name.endsWith(".flp") ||
      file.name.endsWith(".fst") ||
      file.name.endsWith(".fsc") ||
      file.name.endsWith(".fpr")
    ) {
      return TrackFileType.TRACK_FILE_TYPE_SESSION;
    } else {
      return TrackFileType.TRACK_FILE_TYPE_OTHER;
    }
  };

  const handleAddFileToUpload = (newFiles: any[]) => {
    setFiles(newFiles);
  };

  const handleShowVersionTooltip = () => {
    setShowTrackVersionTooltip((prev) => !prev);
  };

  const onSubmit = async (
    values: any,
    {
      resetForm,
      setSubmitting,
    }: {
      resetForm: any;
      setSubmitting: any;
    }
  ) => {
    setSubmitting(true);
    setIsUploading(true);
    handleClose();
    const filesList = files.map((file) => ({
      file,
      name: file.name,
      uploadProgress: 0,
      isCardOpen: true,
    }));
    setUploadingFilesDetailsList(filesList);
    setUploadingCardsStatusList(
      files.map((file) => ({
        name: file.name,
        isCardClosed: false,
      }))
    );
    try {
      const trackFile = new TrackFile();
      if (track) {
        trackFile.setTrackId(track.getId()!);
        trackFile.setTrackIdsList([track.getId()!]);
      } else {
        const matchingTrackIds: string[] = selectedTracksList.map(
          (selectedTrackName) => {
            const matchingTrack = allTracksList.find(
              (track) => track.getTitle() === selectedTrackName
            );
            return matchingTrack ? matchingTrack.getId() : "";
          }
        );
        trackFile.setTrackId(matchingTrackIds[0]);
        trackFile.setTrackIdsList(matchingTrackIds);
      }
      const promises = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const uploadPromise = awaitableUploadToS3(
          userId,
          file,
          `project`,
          file.type,
          awsAccessKeyId,
          awsSecretAccessKey,
          awsSessionToken,
          (progress) => handleProgress(progress, i, filesList)
        );
        promises.push(uploadPromise);
      }
      const fileKeys = await Promise.all(promises);
      for (let i = 0; i < fileKeys.length; i++) {
        const fileKey = fileKeys[i];
        const fileUrl = ASSETS_URL + "/" + fileKey;
        trackFile.setLabel(fileLabel);
        trackFile.setFileUrl(fileUrl);
        trackFile.setOwnerId(userId);
        const fileType = getFileType(files[i]);
        trackFile.setType(fileType);
        trackFile.setFilename(files[i].name);
        trackFile.setFileState(FileState.FILE_STATE_ACTIVE);
        if (parentFolderId) trackFile.setFolderId(parentFolderId);
        const audioMetadata = new AudioMetadata();
        if (fileType !== TrackFileType.TRACK_FILE_TYPE_ARTWORK) {
          const bpm = await getBpm(files[i]);
          audioMetadata.setBpm(bpm);
        }
        trackFile.setAudioMetadata(audioMetadata);
        const invitedCollabList: InvitedCollaborator[] = [];
        emailInviteList.forEach((email) => {
          const newInvitedCollab = new InvitedCollaborator();
          newInvitedCollab.setEmail(email);
          newInvitedCollab.setInvitedCollaboratorState(
            InvitedCollaboratorState.INVITED_COLLABORATOR_STATE_PENDING
          );
          invitedCollabList.push(newInvitedCollab);
        });
        try {
          await sendInvites(
            await getValidAccessToken(),
            emailInviteList,
            addedCollabIds,
            userId,
            `${window.location.origin}/my-files`,
            files[i].name,
            InviteTemplate.INVITE_TEMPLATE_COLLABORATE_FILE
          );
        } catch (error) {
          console.log(error);
        }
        trackFile.setCollaboratorsList(collaborators);
        trackFile.setInvitedCollaboratorsList([...invitedCollabList]);
        const postTrackFileResponse = await postTrackFile(
          trackFile,
          await getValidAccessToken()
        );
        if (postTrackFileResponse instanceof RpcError) {
          throw postTrackFileResponse;
        }
        Mixpanel.track("add_track_file_success", {
          file_type: trackFile.getType(),
        });
        setSubmitting(false);
        setCollaborators([]);
        setEmailInviteList([]);
        handleClose(true, "New File added!");
        if (handleFileAdded) handleFileAdded();
      }
    } catch (error) {
      console.log(error);
      alert(error);
      setSubmitting(false);
    }
  };

  const addCollaborator = (newCollaborator: string) => {
    if (newCollaborator) {
      if (
        collaborators.find(
          (collaborator) => collaborator.getUsername() === newCollaborator
        ) === undefined &&
        usersList.some((user) => user.getUsername() === newCollaborator)
      ) {
        const addedCollab = usersList.find(
          (user) => user.getUsername() === newCollaborator
        );
        if (addedCollab) {
          const newCollab = new Collaborator();
          newCollab.setUserId(addedCollab?.getUserId());
          newCollab.setUsername(addedCollab?.getUsername());
          const updatedCollaborators = [...collaborators, newCollab];

          setAddedCollabIds([...addedCollabIds, addedCollab.getUserId()]);
          setCollaborators(updatedCollaborators);
        }
        const newUserList = usersList.filter(
          (user) => user.getUsername() !== newCollaborator
        );
        setUsersList([...newUserList]);
        setCollabVal("");
      } else {
        toast.info("Username does not exist");
      }
      return true;
    }
  };

  const removeCollaborator = (collaborator: Collaborator) => {
    const updatedCollaborators = collaborators.filter(
      (item) => item !== collaborator
    );
    setCollaborators(updatedCollaborators);

    // updating userIds list that is being passed in sendInvite
    const updatedUserIdList = addedCollabIds.filter(
      (item) => item !== collaborator.getUserId()
    );
    setAddedCollabIds([...updatedUserIdList]);
    const newUser = new User();
    newUser.setUsername(collaborator.getUsername());
    newUser.setUserId(collaborator.getUserId());
    const newUsersList = [...usersList, newUser];
    setUsersList([...newUsersList]);
  };

  const handleCollabInvites = (event: React.SyntheticEvent<Element, Event>) => {
    if (emailInvite) {
      if (emailInvite.match(emailRegex)) {
        setEmailInviteList([...emailInviteList, emailInvite]);
        setEmailInvite("");
      } else {
        toast.info("Invalid email address!");
      }
    }
  };

  const handleFileRemove = (fileId: any) => {
    setFiles((prevFiles) =>
      prevFiles.filter((prevFile) => prevFile.id !== fileId)
    );
  };

  const handleRemoveEmail = (email: string) => {
    const updateEmailList = emailInviteList.filter((item) => item !== email);
    setEmailInviteList(updateEmailList);
  };
  const handleShowCollabTooltip = () => {
    setShowCollabTooltip((prev) => !prev);
  };

  const handleChangeTracksList = (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const values = value as string[];
    const selectedTracksList = [...values];
    setSelectedTracksList(selectedTracksList);
  };

  return (
    <ContainerModal
      open={open}
      onClose={() => handleClose(false)}
      style={{ overflow: "auto" }}
    >
      <Box
        style={{ backgroundColor: APP_BACKGROUND_COLOR, color: TEXT_COLOR }}
        className="form-container"
      >
        <Box style={styles.modalHeaderContainer}>
          <span style={styles.modalHeader}>Add a New Files to This Track</span>
          <IconButton onClick={() => handleClose(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <hr style={{ marginBottom: 30 }} />
        <Formik initialValues={newAddTrack} onSubmit={onSubmit}>
          {({ isSubmitting, setFieldValue, errors }) => (
            <TrackFilesUploadForm
              isSubmitting={isSubmitting}
              handleRemoveEmail={handleRemoveEmail}
              emailInviteList={emailInviteList}
              handleCollabInvites={handleCollabInvites}
              emailInvite={emailInvite}
              setEmailInvite={setEmailInvite}
              removeCollaborator={removeCollaborator}
              collaborators={collaborators}
              collabVal={collabVal}
              addCollaborator={addCollaborator}
              usersList={usersList}
              setCollabVal={setCollabVal}
              showCollabTooltip={showCollabTooltip}
              setShowCollabTooltip={setShowCollabTooltip}
              fileLabel={fileLabel}
              setFileLabel={setFileLabel}
              handleShowCollabTooltip={handleShowCollabTooltip}
              errors={errors}
              showTrackVersionTooltip={showTrackVersionTooltip}
              setShowTrackVersionTooltip={setShowTrackVersionTooltip}
              handleShowVersionTooltip={handleShowVersionTooltip}
              handleFileRemove={handleFileRemove}
              setFieldValue={setFieldValue}
              files={files}
              handleAddFileToUpload={handleAddFileToUpload}
              track={track}
              allTracksList={allTracksList}
              selectedTracksList={selectedTracksList}
              handleChangeTracksList={handleChangeTracksList}
            />
          )}
        </Formik>
      </Box>
    </ContainerModal>
  );
};

export default MultipleFileUploadModal;
